export default "__VITE_ASSET__CDpKdi9O__"